@for (range of preDefinedRanges; track range) {
  <button mat-menu-item (click)="selectRange(range)">
    {{ range.name | translate }}
  </button>
}
